import { TextField } from '@material-ui/core'

export default function FieldsDate({
  classes,
  field,
  handleInput,
  formSelected
}) {
  return(
    <div className={classes.body__fields_date}>
      <TextField
        variant='outlined'
        id="date"
        type="date"
        label={field.summary_title}
        //defaultValue={new Date('dd/mm/yyyy')}
        onChange={evt => handleInput(field.field_id, evt.target.value)}
        required={formSelected.mandatory}
        InputLabelProps={{
          shrink: true,
        }}
        className={classes.body__fields_dateItem}
      />
    </div>
  )
}